module.exports = __webpack_public_path__ + "static/media/reel.009e0cf7.svg";